import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService, I18nModule, UrlModule, User } from '@spartacus/core';
import { IconModule, PageSlotModule } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CustomIconsModule } from 'src/app/custom/icons/custom-icons.module';
import { CustomGenericLinkModule } from 'src/app/spartacus/custom/shared/components/custom-generic-link/custom-generic-link.module';
import { ICON_TYPE } from '../../../../../../custom/icons/icon.model';
import { CustomWishlistService } from '../../../../../custom/cms-components/myaccount/custom-wishlist/facade/custom-wishlist.service';

@Component({
  selector: 'app-custom-login',
  templateUrl: './custom-login.component.html',
  styleUrls: ['./custom-login.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, CustomIconsModule, CustomGenericLinkModule, IconModule]
})
export class CustomLoginComponent implements OnInit {
  iconTypes = ICON_TYPE;
  showMenu = false;
  userName: string;
  user$: Observable<User | undefined>;

  showMyaccountMenu(): void {
    this.showMenu = !this.showMenu;
    if (isPlatformBrowser(this.platformId)) {
      const myTimeout = setTimeout(this.closePopup, 100);
    }
  }

  // TODO, DRF, refactor behavior of popup
  closePopup(): void {
    const loginPup = document.getElementById('wrapper-navigation');
    const closeButton = document.getElementById('close-button');
    if (loginPup !== null) {
      loginPup.addEventListener('mouseleave', (e) => {
        if (closeButton !== null) {
          closeButton.click();
        }
      });
    }
  }

  constructor(
    private auth: AuthService,
    private userAccount: UserAccountFacade,
    private wishListService: CustomWishlistService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.wishListService.loadWishList();
  }

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccount.get();
        } else {
          return of(undefined);
        }
      })
    );
  }
}
